import { render, staticRenderFns } from "./BarChartImagesDuration.vue?vue&type=template&id=336c6b80&scoped=true&"
import script from "./BarChartImagesDuration.vue?vue&type=script&lang=js&"
export * from "./BarChartImagesDuration.vue?vue&type=script&lang=js&"
import style0 from "./BarChartImagesDuration.vue?vue&type=style&index=0&id=336c6b80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336c6b80",
  null
  
)

export default component.exports